export default __webpack_public_path__ + "static/media/needadmin.b00b622e.mp3";